<div class="session onboarding">
  <div fxLayout="column" fxLayoutAlign="center center" class="boarding-container" [ngClass]="'bc-step-' + step"
    [ngSwitch]="step">

    <ng-container *ngSwitchCase="0">
      <img src="./assets/images/onboarding/step-1-banana-1.png" alt="banana" title="banana" class="banana banana-step-0">
      <img src="./assets/images/onboarding/step-0-monkey.png" alt="Monkey" title="Monkey" class="step-0-monkey"
        width="220px">
     
      <div class="wrapper-white wrapper-step-0">
        <img src="./assets/images/onboarding/step-0-queue.png" alt="Monkey" title="Monkey" class="step-0-queue">
        <div class="content">
            <img src="./assets/images/onboarding/check-wizard.png" alt="welcome" title="welcome" class="check-step-0">
          <h2>
            <span class="fontfamily-bold-italic">{{ 'onboarding.message.welcome' | translate }}</span>
            <span class="fontfamily-italic">
              <br><br>
              {{ 'onboarding.message.created_successfully' | translate }}
              <br>
              {{ 'onboarding.message.configure' | translate }}

            </span>
          </h2>
        </div>
        <div class="action">
          <button data-ci="first-step" mat-raised-button class="gradient-background" (click)="goNextStep()">
            {{ 'onboarding.action.go' | translate }}
          </button>
        </div>
      </div>
      
    </ng-container>

    <ng-container *ngSwitchCase="1">
          <img src="./assets/images/onboarding/step-2-banana-1.png" alt="banana" title="banana" class="banana banana-step-1">

      <ng-container *ngIf="did && did.id; else notDid">
        <div class="wrapper-white wrapper-step-1">
            <img src="./assets/images/onboarding/step-1-monkey.png" alt="Monkey" title="Monkey" class="step-1-monkey">
          
          <div class="content content-step-1">
            <h2>
              <span class="fontfamily-bold-italic">{{ 'onboarding.message.give_number_1' | translate }} </span>
              <span class="fontfamily-italic">{{ 'onboarding.message.give_number_2' | translate }} Tu peux l'appeler dés maintenant pour tester.</span>
            </h2>
            <div class="border-blue"><span class="number fontfamily-bold"> {{did.number}}</span></div>
          </div>
          <div class="action">
            <button mat-raised-button class="gradient-background" (click)="goNextStep()">
              {{ 'onboarding.action.next' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      
      <ng-template #notDid>
        <div class="wrapper-white wrapper-step-1">
            <img src="./assets/images/onboarding/step-1-monkey.png" alt="Monkey" title="Monkey" class="step-1-monkey">
          <div class="content content-step-1">
            <h2>
              <span class="fontfamily-bold-italic">{{ 'onboarding.message.not_did_number' | translate }}</span> <br>
              <span class="fontfamily-italic">{{ 'onboarding.message.contact_support' | translate }}</span>
            </h2>
          </div>
          <div class="action">
            <button mat-raised-button class="gradient-background" (click)="goNextStep()">
              {{ 'onboarding.action.next' | translate }}
            </button>
          </div>
        </div>
      </ng-template>
      
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <img src="./assets/images/onboarding/step-3-banana-1.png" alt="banana" title="banana" class="banana banana-step-3">
      
      <div class="wrapper-white wrapper-step-3">
        <img src="./assets/images/onboarding/step-6-monkey.png" alt="Monkey" title="Monkey" class="step-3-monkey">
        <img src="./assets/images/onboarding/step-6-monkey-1.png" alt="Monkey" title="Monkey" class="step-3-monkey-1">
        <div class="content content-step-3">
          <h2>
            <span class="fontfamily-italic">Graam est constitué de 2 parties essentielles :</span><br>
            <span class="fontfamily-bold-italic">le tableau de bord et l'application mobile</span>
          </h2>
          <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex class="text-center">
                <img src="assets/images/onboarding/appli-desktop.png" alt="Application desktop" title="Application desktop" class="appli-desktop"/>
                <div class="text-appli-desktop fontfamily-italic ">
                  Tu peux utiliser le tableau de bord pour consulter les statistiques, faire du management et plein profiter de plein d'autres fonctionnalités !
                </div>
            </div>
            <div fxFlex class="text-center">
                <img src="assets/images/onboarding/plus.png" alt="plus" title="plus" class="plus"/>
            </div>
            <div fxFlex class="text-center">
                <div class="text-appli-mobile fontfamily-italic">
                    Avec l'application, tu peux lancer et recevoir des appels !
                </div>
                <img src="assets/images/onboarding/appli-mobile.png" alt="application mobile" title="application mobile" class="appli-mobile"/>
            </div>
          </div>
        </div>
        <div class="action">
          <button data-ci="third-step" mat-raised-button class="gradient-background" (click)="goNextStep()">
            Suivant
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="3">
      <img src="./assets/images/onboarding/step-4-banana-1.png" alt="banana" title="banana" class="banana banana-step-3">
      
     
      <div class="wrapper-white wrapper-step-3">
        <img src="./assets/images/onboarding/step-7-monkey.png" alt="Monkey" title="Monkey" class="step-4-monkey">
        <div class="content content-step-4">
          <h2>
            <span class="fontfamily-bold-italic">{{ 'onboarding.message.download_application' | translate }}</span>
            <span class="fontfamily-italic"> {{ 'onboarding.message.connect_application' | translate }}</span>
          </h2>
          <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex class="text-right">
                <img width="185px" src="assets/images/onboarding/appli-mobile-1.png" alt="application mobile" title="application mobile" />
            </div>
            <div fxFlex class="text-center">
                <div class="text-app">Disponible sur</div>
                <div>
                  <img src="assets/images/onboarding/appli-windows.png" alt="Windows application"title="Windows application" class="ml-1 mr-1"/>
                  <img src="assets/images/onboarding/appli-apple.png" alt="IOS application"title="IOS application" class="ml-1 mr-1"/>
                </div>
            </div>
          </div>
        </div>
        <div class="action mt-2">
          <button data-ci="third-step" mat-raised-button class="gradient-background" (click)="goNextStep()">
            {{ 'onboarding.action.download' | translate }}
          </button>
        </div>
        <div class="action link-skip">
            <a (click)="goToHomepage()">Je l'ai déjà téléchargée</a>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="4">
      <img src="./assets/images/onboarding/step-5-banana-1.png" alt="banana" title="banana" class="banana banana-step-5">
     
      <div class="wrapper-white wrapper-step-5">
        <img src="./assets/images/onboarding/step-8-monkey.png" alt="Monkey" title="Monkey" class="step-5-monkey">
        <div class="content content-step-1">
          <h2>
            <span class="fontfamily-bold-italic">{{ 'onboarding.message.everything_works' | translate }}</span><br><br>
            <span class="fontfamily-italic"> {{ 'onboarding.message.guide_in_app' | translate }}</span>
          </h2>
        </div>
        <div class="action">
          <button data-ci="fifth-step" mat-raised-button class="gradient-background" (click)="goFinishBoarding()">
            {{ 'onboarding.action.go' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
